import { ProductModule } from 'product-modules/domain/product-module';

/**
 * Matches dashboard / platform billing: move start date is allowed only when
 * `settings.billing.allow_start_date_change` is explicitly true on the product module definition.
 * Omitted or false disables the embed flow (legacy definitions must set the flag to opt in).
 */
export const isAllowStartDateChangeEnabled = (productModule: ProductModule | undefined): boolean =>
  productModule?.productModuleDefinition?.settings.billing.allowStartDateChange === true;
